import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Header from "../components/Header"; // Adjust the path as necessary
const qz = require("qz-tray");

function PrintReceipt() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ticketNumber, setTicketNumber] = useState("");
  const [ticketId, setTicketId] = useState("");
  const [inlineErrorMessage, setInlineErrorMessage] = useState("");
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState(""); // New state for API error message
  const { branchDetails } = location.state || {};
  const { encryptPayload, decryptPayload } = require("../utils/custom-hash");

const handlePrintViaQZTray = async (ticketData, settings) => {

   const leftAlignCommand = '\x1B\x61\x00'; // ESC a 0 => Left align

  const ticketContent = [

    leftAlignCommand, 

    "===============================",
    `${branchDetails?.branchName || "Branch Name"}`,
    "===============================",
    `Ticket No   : ${ticketData.token}`,
    `Service     : ${ticketData.serviceName}`,
    `Status      : ${ticketData.status}`,
    `Issued At   : ${new Date(ticketData.issueTime).toLocaleString()}`,
    // `Name        : ${ticketData.customerName}`,
    // `Email       : ${ticketData.customerEmail}`,
    // `Contact     : ${ticketData.customerContact}`,
    "-------------------------------",
    "Thank you for visiting!",
    "===============================",
    "" // extra line for spacing
  ].join("\n");  // <== Guarantees clean newlines

  const cutCommand = '\x1D\x56\x42\x00'; // Full cut command (for Epson-style printers)

  try {
    await qz.websocket.connect();
    const printerData = await qz.printers.getDefault();
    // console.log("FOUND PRINTER:", printerData); // Check the printer details

    let config = qz.configs.create(printerData); // Get printer config

    // First print ticket content
    await qz.print(config, [{
      type: 'raw',
      flavor: 'plain',
      data: ticketContent + cutCommand
    }]);

    setTicketModalOpen(true); // Display modal after printing

  } catch (err) {
    console.error("Error during printing:", err);
  } finally {
    await qz.websocket.disconnect();
  }
};


  const handleSubmit = async () => {
    if (ticketNumber.trim() === "") {
      setInlineErrorMessage("Please enter a Ticket Number.");
      return;
    }

    setInlineErrorMessage(""); // Clear inline error message
    setApiErrorMessage(""); // Clear API error message

    try {
      const payload = {
        token: ticketNumber,
        branchId: branchDetails?.branchId,
      };

      const encryptedPayload = await encryptPayload(payload);
      // console.log("Ticket Payload:", encryptedPayload);

      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/kiosk/token/print`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ encryptedPayload }),
        }
      );

      if (!response.ok) throw new Error("No ticket found");

      const result = await response.json();

      if (result.success) {
        const ticketData = decryptPayload(result.ticket);
        // console.log('@@@ticketData--', ticketData);
        setTicketId(ticketData.token);

        // const printPayload = {
        //   payload: {
        //     tokenno: ticketNumber,
        //     status: ticketData.status,
        //     issueTime: ticketData.issueTime,
        //     serviceName: ticketData.serviceName,
        //     counterName: ticketData.counterName,
        //     customerName: ticketData.customerName,
        //     customerEmail: ticketData.customerEmail,
        //     customerContact: ticketData.customerContact
        //   },
        //   config: {
        //     branchId: result.settings.branchId,
        //     hasImageHeader: result.settings.hasImageHeader,
        //     imageHeader: result.settings.imageHeader,
        //     dateFormat: result.settings.dateFormat,
        //     contactNumber: result.settings.contactNumber,
        //     hasTextHeader: result.settings.hasTextHeader,
        //     hideTheTime: result.settings.hideTheTime,
        //     printDuplicate: result.settings.printDuplicate,
        //     printEstimatedWaitingTime: result.settings.printEstimatedWaitingTime,
        //     printQueuePosition: result.settings.printQueuePosition,
        //     paperSize: result.settings.paperSize,
        //     textHeader: result.settings.textHeader
        //   }
        // };

        // === QZ Tray (Shreyans Printer) Printing ===
        await handlePrintViaQZTray(ticketData, result.settings);

        // === Show Modal ===
        // setTicketModalOpen(true);
      } else {
        console.error(result.message || "Error printing ticket.");
        setApiErrorMessage(result.message || "Error printing ticket.");
        navigate("/");
      }
    } catch (error) {
      console.error("Error submitting ticket:", error);
      setApiErrorMessage(error.message);
    }
  };

  const handleClose = () => {
    setTicketModalOpen(false);
    navigate("/");
  };

  const handleCancel = () => {
    setTicketNumber("");
    navigate("/");
  };

  return (
    <Box sx={{ minHeight: "100vh", width: "100%", backgroundColor: "#f2f2f2", display: "flex", flexDirection: "column" }}>
      <Header />
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "center", padding: 2 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={6} mt={10}>
            <Card sx={{ p: 4, borderRadius: 2, boxShadow: 3, backgroundColor: "#ffffff", textAlign: "center", margin: "0 auto" }}>
              <Typography variant="h5" fontWeight="bold" mb={2}>Print Receipt</Typography>
              <TextField
                name="ticketNumber"
                label="Enter Ticket Number"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{ style: { borderRadius: 4 } }}
                InputLabelProps={{
                  sx: {
                    color: "#333",
                    "&.Mui-focused": { color: "#1877f2" },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#ddd" },
                    "&:hover fieldset": { borderColor: "#ccc" },
                    "&.Mui-focused fieldset": { borderColor: "#1877f2" },
                  },
                  mb: 1,
                }}
                value={ticketNumber}
                onChange={(e) => setTicketNumber(e.target.value)}
                error={!!inlineErrorMessage}
                helperText={inlineErrorMessage}
              />

              {apiErrorMessage && (
                <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                  {apiErrorMessage}
                </Typography>
              )}
              <Box mt={2} display="flex" justifyContent="space-between">
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: "#1877f2",
                    color: "#1877f2",
                    borderRadius: 2,
                    height: 50,
                    width: "48%",
                    "&:hover": { borderColor: "#0056b3" },
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1877f2",
                    color: "white",
                    borderRadius: 2,
                    height: 50,
                    width: "48%",
                    "&:hover": { backgroundColor: "#0056b3" },
                  }}
                  onClick={handleSubmit}
                >
                  Print
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Dialog open={ticketModalOpen} onClose={() => setTicketModalOpen(false)} PaperProps={{ sx: { borderRadius: 2, p: 2, boxShadow: 3, opacity: 1 } }}>
        <DialogTitle>
          <Box display="flex" justifyContent="center" mb={1}>
            <CheckCircleIcon style={{ color: "#4caf50", fontSize: 60 }} />
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" align="center">
            Your ticket has been printed, please collect it from the printer.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default PrintReceipt;
